module.exports = __webpack_public_path__ + "img/pen-off.cab3d59e.svg";